
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/[slug]/llengua-de-signes",
      function () {
        return require("private-next-pages/3cat/[slug]/llengua-de-signes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/[slug]/llengua-de-signes"])
      });
    }
  